import { Select as SelectPrimitive } from "@base-ui/react/select"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import ScrollShadow from "src/components/ScrollShadow"

const SelectContent = ({
  className,
  children,
  side = "bottom",
  sideOffset = 5,
  align = "start",
  alignOffset = 0,
  alignItemWithTrigger = false,
  ...props
}) => (
  <SelectPrimitive.Portal>
    <SelectPrimitive.Positioner
      side={side}
      sideOffset={sideOffset}
      align={align}
      alignOffset={alignOffset}
      alignItemWithTrigger={alignItemWithTrigger}
      className="z-50"
    >
      <SelectPrimitive.Popup
        data-slot="select-content"
        className={classNames(
          "min-w-[180px] rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
          className
        )}
        style={{ minWidth: "var(--anchor-width)" }}
        {...props}
      >
        <ScrollShadow
          direction="vertical"
          scrollContainerClassName="max-h-60 p-1"
        >
          {children}
        </ScrollShadow>
      </SelectPrimitive.Popup>
    </SelectPrimitive.Positioner>
  </SelectPrimitive.Portal>
)

SelectContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  side: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  sideOffset: PropTypes.number,
  align: PropTypes.oneOf(["start", "center", "end"]),
  alignOffset: PropTypes.number,
  alignItemWithTrigger: PropTypes.bool,
}

export default SelectContent
